import { render, staticRenderFns } from "./ProjectBlockLayout.vue?vue&type=template&id=11aeb5c2&scoped=true&"
import script from "./ProjectBlockLayout.vue?vue&type=script&lang=js&"
export * from "./ProjectBlockLayout.vue?vue&type=script&lang=js&"
import style0 from "./ProjectBlockLayout.vue?vue&type=style&index=0&id=11aeb5c2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11aeb5c2",
  null
  
)

export default component.exports